// extracted by mini-css-extract-plugin
export var carrierIcon = "_tx-0";
export var carrierLogo = "_tx-1";
export var detailsSection = "_tx-2";